import { render, staticRenderFns } from "./IpBws.vue?vue&type=template&id=869f4fac"
import script from "./IpBws.vue?vue&type=script&lang=js"
export * from "./IpBws.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports